module.exports = __webpack_public_path__ + "static/img/engine.d578b41a.png";